var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIconOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.5,
    height: 32.508,
    viewBox: "0 0 32.5 32.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-thumb-up",
    "data-name": "Icon open-thumb-up",
    d: "M20.115,0A2.808,2.808,0,0,0,18,1.53c-.585,1.17-4.905,9.855-5.76,10.71A4.445,4.445,0,0,1,9,13.5v18H24.75a2.33,2.33,0,0,0,2.115-1.4S31.5,17.01,31.5,15.75a2.228,2.228,0,0,0-2.25-2.25H22.5a2.317,2.317,0,0,1-2.25-2.25c0-1.125,1.755-7.11,2.115-8.28A2.266,2.266,0,0,0,20.97.135,1.9,1.9,0,0,0,20.115,0ZM0,13.5v18H4.5v-18Z",
    transform: "translate(0.5 0.508)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIconOutline);
export default __webpack_public_path__ + "static/media/likeIconOutline.19a3e38265ade6bede3c9933735c253b.svg";
export { ForwardRef as ReactComponent };